/* LOVEQUEEN — Film reveal
 * スクロールに合わせて、印画紙が現像されるように静かに現れる。
 * prefers-reduced-motion 時は何もしない。
 */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var SELECTORS = [
    '.section-header',
    '.featured-collection-grid-item',
    '.card-product',
    '.MuseumGallery__Item',
    '.lq-lookbook__item',
    '.lq-lookbook__header',
    '.lq-ed__media',
    '.lq-ed__body',
    '.lq-fs__header',
    '.lq-fs__card',
    '.lq-footer-statement__inner',
    '.footer-block-column'
  ].join(',');

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lq-in');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  function prepare(root) {
    var els = (root || document).querySelectorAll(SELECTORS);
    els.forEach(function (el) {
      if (el.dataset.lqIo) return;
      el.dataset.lqIo = '1';

      // 既に画面内にある要素(ファーストビュー)は動かさない
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.9 && rect.bottom > 0) return;

      // 兄弟間で控えめな時間差(コンタクトシートをめくるように)
      var siblings = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--lq-io-delay', Math.min(siblings % 6, 5) * 0.07 + 's');

      el.classList.add('lq-io');
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { prepare(document); });
  } else {
    prepare(document);
  }

  // テーマエディタでセクションが再描画された時
  document.addEventListener('shopify:section:load', function (e) { prepare(e.target); });
})();
